/**
 * Where did this visitor come from? Captured once per browser on first
 * visit (first touch) and refreshed whenever a tagged link brings them back
 * (last touch), then sent with registration so every push — a WhatsApp
 * broadcast, a Facebook post, a radio mention — becomes measurable.
 *
 * Tag links with ?utm_source=… (or the short form ?ref=…). Nothing here is
 * personal data: landing path, referrer host, campaign tags, a timestamp.
 */
const FIRST_KEY = 'eqaya_first_touch';
const LAST_KEY = 'eqaya_last_touch';

function read(key) {
  try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : null; } catch (_) { return null; }
}
function write(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* private mode etc. */ }
}

function touchFromLocation() {
  const params = new URLSearchParams(window.location.search || '');
  const pick = (k) => (params.get(k) || '').trim().slice(0, 100) || null;
  let referrerHost = null;
  try { referrerHost = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : null; } catch (_) { /* ignore */ }
  return {
    at: new Date().toISOString(),
    landing: (window.location.pathname || '/').slice(0, 200),
    referrer: referrerHost,
    source: pick('utm_source') || pick('ref'),
    medium: pick('utm_medium'),
    campaign: pick('utm_campaign'),
    content: pick('utm_content'),
  };
}

/** Call once on app load, before routing. Safe to call repeatedly. */
export function captureFirstTouch() {
  if (typeof window === 'undefined') return;
  const touch = touchFromLocation();
  // Internal navigation (referrer is our own host) with no tags carries no
  // information — never overwrite a real first touch with it.
  const own = touch.referrer && window.location.hostname.replace(/^www\./, '') === touch.referrer;
  if (!read(FIRST_KEY)) write(FIRST_KEY, own ? { ...touch, referrer: null } : touch);
  if (touch.source || touch.campaign) write(LAST_KEY, touch);
}

/** What to send with registration. */
export function getAcquisition() {
  const first = read(FIRST_KEY);
  const last = read(LAST_KEY);
  if (!first && !last) return null;
  return { first, last };
}
